
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"600","height":"300","viewBox":"0 0 12 6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#009B3A","d":"M0 0h12v6H0"}}),_c('path',{attrs:{"stroke":"#FED100","d":"M-6 9L18-3V9L-6-3"}})])
          )
        }
      }
    